import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResolveAuthorityClaimJurisdictionQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type ResolveAuthorityClaimJurisdictionQuery = { __typename?: 'query_root', resolve_authority_claim_jurisdiction: { __typename?: 'ResolveAuthorityClaimJurisdictionOutput', jurisdiction_id?: any | null, match_source?: string | null, can_add_jurisdiction: boolean } };


export const ResolveAuthorityClaimJurisdictionDocument = gql`
    query ResolveAuthorityClaimJurisdiction($email: String!) {
  resolve_authority_claim_jurisdiction(email: $email) {
    jurisdiction_id
    match_source
    can_add_jurisdiction
  }
}
    `;

/**
 * __useResolveAuthorityClaimJurisdictionQuery__
 *
 * To run a query within a React component, call `useResolveAuthorityClaimJurisdictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveAuthorityClaimJurisdictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveAuthorityClaimJurisdictionQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResolveAuthorityClaimJurisdictionQuery(baseOptions: Apollo.QueryHookOptions<ResolveAuthorityClaimJurisdictionQuery, ResolveAuthorityClaimJurisdictionQueryVariables> & ({ variables: ResolveAuthorityClaimJurisdictionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveAuthorityClaimJurisdictionQuery, ResolveAuthorityClaimJurisdictionQueryVariables>(ResolveAuthorityClaimJurisdictionDocument, options);
      }
export function useResolveAuthorityClaimJurisdictionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveAuthorityClaimJurisdictionQuery, ResolveAuthorityClaimJurisdictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveAuthorityClaimJurisdictionQuery, ResolveAuthorityClaimJurisdictionQueryVariables>(ResolveAuthorityClaimJurisdictionDocument, options);
        }
export function useResolveAuthorityClaimJurisdictionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveAuthorityClaimJurisdictionQuery, ResolveAuthorityClaimJurisdictionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveAuthorityClaimJurisdictionQuery, ResolveAuthorityClaimJurisdictionQueryVariables>(ResolveAuthorityClaimJurisdictionDocument, options);
        }
export type ResolveAuthorityClaimJurisdictionQueryHookResult = ReturnType<typeof useResolveAuthorityClaimJurisdictionQuery>;
export type ResolveAuthorityClaimJurisdictionLazyQueryHookResult = ReturnType<typeof useResolveAuthorityClaimJurisdictionLazyQuery>;
export type ResolveAuthorityClaimJurisdictionSuspenseQueryHookResult = ReturnType<typeof useResolveAuthorityClaimJurisdictionSuspenseQuery>;
export type ResolveAuthorityClaimJurisdictionQueryResult = Apollo.QueryResult<ResolveAuthorityClaimJurisdictionQuery, ResolveAuthorityClaimJurisdictionQueryVariables>;